<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 16:53:09
 * @LastEditTime: 2019-08-18 12:04:24
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="footer">
      <el-button type="primary" @click="back">返回</el-button>
    </div>
    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="门店编号:">
        <el-input v-model="form.store_sn" clearable></el-input>
      </el-form-item>
      <el-form-item label="门店名称:">
        <el-input v-model="form.storename" clearable></el-input>
      </el-form-item>
      <el-form-item label="门店状态:">
        <el-select v-model="form.status" placeholder="门店状态" clearable>
          <el-option value="">全部</el-option>
          <el-option value="1">正常</el-option>
          <el-option value="2">禁用</el-option>
          <el-option value="3">删除</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门店类型:">
        <el-select v-model="form.store_type_id" placeholder="门店类型" clearable>
          <el-option
            v-for="i in storeList"
            :key="i.id"
            :label="i.type_name"
            :value="i.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        <!-- <el-button>导出</el-button> -->
      </el-form-item>
    </el-form>
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      v-loading="loading"
      stripe
      height="350"
      style="width: 100%"
    >
      <el-table-column label="门店编号" width="140" prop="store_sn" fixed>
      </el-table-column>
      <el-table-column prop="storename" label="门店名称" fixed> </el-table-column>
      <el-table-column prop="type_name" label="门店类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" label="门店地址" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="person" label="负责人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="addtime" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="product_name" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">正常</span>
          <span v-if="scope.row.status == 2">禁用</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="querys(scope.row)"
            >礼品统计</el-button
          >
          <el-button type="text" size="small" @click="detail(scope.row)">详情</el-button>

          <!-- <el-button
            type="text"
            size="small"
            @click="disables(scope.row, 2)"
            v-if="scope.row.status != 2"
            >禁用</el-button
          > -->
          <!-- <el-button
            type="text"
            size="small"
            @click="disables(scope.row, 1)"
            v-if="scope.row.status == 2"
            >启用</el-button
          > -->

          <!-- <el-button type="text" size="small" @click="disables(scope.row, 3)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    >
    </el-pagination>
    <!--发货-->
    <deliverDialog v-if="deliverDialog" v-on:handleClose="deliverDialog = false">
    </deliverDialog>
    <!--物流码明细-->
    <instockDetailDialog
      v-if="instockDetailDialogVisable"
      v-bind:detailData="stock_in_sn"
      v-on:handleClose="instockDetailDialogVisable = false"
    >
    </instockDetailDialog>
  </div>
</template>

<script>
// import deliverDialog from './deliverDialog';
// import instockDetailDialog from './instockDetail'
export default {
  name: "lowerStoreManage",
  data() {
    return {
      loading: false,
      deliverDialog: false,
      form: {
        dealer_id: "",
        region_city: "",
        region_province: "",
        region_city: "",
        region_country: "",
        store_img: [],
      },
      storeList: [],
      tableData: [],
      instockDetailDialogVisable: false,
      stock_in_sn: "", //查看明细传递的入库单号
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      dealerLevel: [], //经销商级别,
      form1: {
        from_sn: "",
        dealer_name: "",
        from_level_id: "",
      },
      countrys: [],
      provinces: [],
      citys: [],
      areas: [],
    };
  },
  methods: {
    // 获取四级联动
    getcountry() {
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 1,
        parent_id: "",
      })
        .then((res) => {
          this.countrys = res.data;
          this.citys = [];
          this.areas = [];
          this.provinces = [];
        })
        .catch((error) => {});
    },
    getprovinces() {
      this.citys = [];
      this.provinces = [];
      this.areas = [];
      this.form.region_province = "";
      this.form.region_city = "";
      this.form.region_area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 2,
        parent_id: this.form.region_country,
      })
        .then((res) => {
          this.provinces = res.data;
        })
        .catch((error) => {});
    },
    getcity() {
      this.$forceUpdate();
      this.citys = [];
      this.areas = [];
      this.form.region_city = "";
      this.form.region_area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 2,
        parent_id: this.form.region_province,
      })
        .then((res) => {
          this.citys = res.data;
        })
        .catch((error) => {});
    },
    getArea() {
      this.$forceUpdate();
      this.areas = [];
      this.form.region_area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 2,
        parent_id: this.form.region_city,
      })
        .then((res) => {
          this.areas = res.data;
        })
        .catch((error) => {});
    },

    getStoreLevel() {
      this.$get("logistics_2", "/vstore/dealer_pc/storeType")
        .then((res) => {
          this.storeList = res.data;
        })
        .catch((error) => {});
    },

    // 查看详情
    detail(data) {
      this.$router.push({
        name: "lowerStoreDetail",
        query: {
          id: data.id,
          dealer_id: this.$route.query.id,
        },
      });
    },
    querys(data) {
      this.$router.push({
        name: "lowerStoreVerifyAndExpense",
        query: {
          store_sn: data.store_sn,
          dealer_id: this.$route.query.id,
        },
      });
    },
    //选择经销商
    getDealerInfo(val) {
      this.form1.from_sn = val.dealer_sn;
      this.form1.dealer_name = val.dealer_name;
    },
    //请求列表数据
    onSearch() {
      this.loading = true;
      this.form.dealer_id = this.$route.query.id;
      this.$get("logistics_2", "/vstore/dealer_pc/lowerstorelist", {
        lang: "",
        ...this.form,
        per_page: this.pageSize,
        page: this.pageNo,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.totalSize = res.data.total;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    back() {
      this.$router.push({
        name: "next_leve",
      });
    },
    //添加入库
    add() {
      this.$router.push({
        name: "addStore",
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //发货
    deliver(row) {
      this.deliverDialog = true;
    },
    //删除
    disables(row, temp) {
      if (temp == 2) {
        this.$confirm("是否禁用该门店?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var url = "/vstore/dealer_pc/setstatus";
            this.$get("logistics_2", url, {
              id: row.id,
              status: temp,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    type: "success",
                    message: "禁用成功!",
                  });
                  this.onSearch();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消禁用",
            });
          });
      } else if (temp == 3) {
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var url = "/vstore/dealer_pc/setstatus";
            this.$get("logistics_2", url, {
              id: row.id,
              status: temp,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.onSearch();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$confirm("是否启用?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var url = "/vstore/dealer_pc/setstatus";
            this.$get("logistics_2", url, {
              id: row.id,
              status: temp,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    type: "success",
                    message: "启用成功!",
                  });
                  this.onSearch();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消启用",
            });
          });
      }
    },
  },
  created() {
    this.onSearch();
    this.getStoreLevel();
    this.getcountry();
  },
  components: {
    // deliverDialog,instockDetailDialog
  },
};
</script>
<style lang="scss" scoped></style>
